export default "__VITE_ASSET__D7XFrX0T__"